const APP_SCHEME = process.env.REACT_APP_APP_SCHEME || "owajoo";

// Store badge'leri (Footer, MainPage) ve "See in app" fallback'i bu URL'leri kullaniyor — tek kaynak burasi.
// Fallback sabitleri BILEREK var: bunlar gizli deger degil, public store adresleri. Env eksik/yanlis
// bake edildiginde badge'ler sessizce olu <a> olarak render ediliyordu (React undefined href'i basmaz)
// ve openInApp store'a hic dusemiyordu. Sabit fallback bu sessiz kirilmayi engelliyor.
export const IOS_APP_STORE_URL =
    process.env.REACT_APP_IOS_APP_STORE_URL || "https://apps.apple.com/us/app/owajoo/id6760220769";
export const ANDROID_PLAY_STORE_URL =
    process.env.REACT_APP_ANDROID_PLAY_STORE_URL || "https://play.google.com/store/apps/details?id=com.owajoo.owajoo";

// Cihaza gore store'a yonlendiren kisa link (nginx'te /app -> App Store / Play Store 302).
// QR kodlari da bu adresi tasiyor.
export const APP_REDIRECT_PATH = "/app";

const ANDROID_PACKAGE = (() => {
    if (!ANDROID_PLAY_STORE_URL) return "";
    try {
        return new URL(ANDROID_PLAY_STORE_URL).searchParams.get("id") || "";
    } catch {
        return "";
    }
})();

export const detectPlatform = () => {
    if (typeof navigator === "undefined") return "desktop";
    const ua = navigator.userAgent;
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
    if (/Android/i.test(ua)) return "android";
    return "desktop";
};

export const isMobile = () => {
    const p = detectPlatform();
    return p === "ios" || p === "android";
};

export const openInApp = (resource, id) => {
    const platform = detectPlatform();
    if (platform === "desktop") return;

    if (platform === "android") {
        if (!ANDROID_PACKAGE) {
            if (ANDROID_PLAY_STORE_URL) window.location.href = ANDROID_PLAY_STORE_URL;
            return;
        }
        const fallback = encodeURIComponent(ANDROID_PLAY_STORE_URL || "");
        const intent = `intent://${resource}/${id}#Intent;scheme=${APP_SCHEME};package=${ANDROID_PACKAGE};S.browser_fallback_url=${fallback};end`;
        window.location.href = intent;
        return;
    }

    const deeplink = `${APP_SCHEME}://${resource}/${id}`;
    const start = Date.now();
    let appOpened = false;

    const onVisibilityChange = () => {
        if (document.hidden) appOpened = true;
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    window.location.href = deeplink;

    setTimeout(() => {
        document.removeEventListener("visibilitychange", onVisibilityChange);
        if (!appOpened && !document.hidden && Date.now() - start < 2500 && IOS_APP_STORE_URL) {
            window.location.href = IOS_APP_STORE_URL;
        }
    }, 1500);
};
